import { NavigateFunction } from 'react-router-dom'

export let navigate: NavigateFunction = (val) => null

export const setNavigate = (globalNavigate: NavigateFunction): void => {
  navigate = globalNavigate
}
